/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';

// material ui
import { Popover, ListItem, ListItemIcon, ListItemText, List } from '@mui/material';
import { makeStyles } from '@mui/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';

// i18n
import { useTranslation } from 'react-i18next';

// makeStyle
const useStyles = makeStyles((theme) => ({
    input: {
        display: 'none'
    }
}));

const ImagePopoverOptions = ({ openPopOver, anchorEl, handlePopoverClose, setOpenDialog, handleDeleteAvatarOpen }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    return (
        <>
            <Popover
                open={openPopOver}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
            >
                <List dense>
                    <ListItem onClick={() => setOpenDialog(true)}>
                        <ListItemIcon>
                            <SearchIcon />
                        </ListItemIcon>
                        <ListItemText primary={t('UploadNewImage')} />
                    </ListItem>
                    <ListItem onClick={() => handleDeleteAvatarOpen()}>
                        <ListItemIcon>
                            <DeleteIcon />
                        </ListItemIcon>
                        <ListItemText primary={t('Delete')} />
                    </ListItem>
                </List>
            </Popover>
        </>
    );
};

export default ImagePopoverOptions;
